import { render, staticRenderFns } from "./PricingTooltips.vue?vue&type=template&id=2bdc4127&scoped=true&"
import script from "./PricingTooltips.vue?vue&type=script&lang=js&"
export * from "./PricingTooltips.vue?vue&type=script&lang=js&"
import style0 from "./PricingTooltips.vue?vue&type=style&index=0&id=2bdc4127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc4127",
  null
  
)

export default component.exports